module.exports = __webpack_public_path__ + "static/media/signal.34292c19.svg";